// This icon file is generated automatically.
var PHourglassOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.6 2.97V.87h1.34c.07 0 .12-.05.12-.12v-.88a.13.13 0 00-.12-.12H1.06a.13.13 0 00-.12.13v.87c0 .07.05.13.12.13h1.35v2.09c0 1.27.66 2.4 1.66 3.03A3.59 3.59 0 002.4 9.03v2.1H1.06a.13.13 0 00-.12.12v.88c0 .06.05.12.12.12h9.88c.07 0 .12-.06.12-.13v-.87a.13.13 0 00-.12-.13H9.59V9.04c0-1.27-.66-2.4-1.66-3.03 1-.64 1.66-1.76 1.66-3.03zM8.46 9.03v2.1H3.53v-2.1a2.45 2.45 0 014.21-1.75c.47.47.73 1.1.73 1.75zm0-6.06a2.45 2.45 0 01-4.21 1.75 2.45 2.45 0 01-.73-1.75V.87h4.94v2.1z", "fill-rule": "nonzero" } }] }, "name": "p-hourglass", "theme": "outlined" };
export default PHourglassOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PHourglassOutlined.js
// module id = 3457
// module chunks = 0